import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import {
  PlaceGusDictionaryRequestBody,
  PlaceGusField,
  PlaceGusFieldFromApi,
} from './place-gus-dictionary.model';

@Injectable({
  providedIn: 'root',
})
export class PlaceGusDictionaryService {
  private dictionary: Record<string, Observable<PlaceGusField[]>> = {};
  constructor(private httpClient: HttpClient) {}

  get(body: PlaceGusDictionaryRequestBody): Observable<PlaceGusField[]> {
    const cacheKey = body.getCacheKey();
    if (!this.dictionary[cacheKey]) {
      this.dictionary[cacheKey] = this.httpClient
        .post<PlaceGusFieldFromApi[]>(`/api/emuia/gus/slo/miejscowosci`, body)
        .pipe(
          map((data) =>
            data.map((fieldFromApi) =>
              PlaceGusField.fromApiToApp(fieldFromApi),
            ),
          ),
          shareReplay(1),
        );
    }

    return this.dictionary[cacheKey];
  }
}
